export default {"src":"/_next/static/media/XML.1ed98ede.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};